import application from 'application';
import serverInterface from 'server-interface';

import {
  findIndexByPropertyValue
} from 'utilities/collection';

import {
  applyTraits
} from 'utilities/javascript';
import InitializeOnce from 'utilities/javascript/initialize-once';

import externalEventCodes from 'event-system/codes/external';
import internalEventCodes from 'event-system/codes/internal';

class UserSpaceConversationLabelsManager {

  constructor(application) {

    this.initializePromise = null;
    this.userSpaceConversationLabels = [];

    this.application = application;

  }

  async doInitialize() {

    this.registerEventHandlers();

    await this.loadAll();

  }

  tryAddUserSpaceConversationLabel(userSpaceConversationLabel) {

    const userSpaceConversationLabelIndex = findIndexByPropertyValue(this.userSpaceConversationLabels, '_id', userSpaceConversationLabel._id);

    if (userSpaceConversationLabelIndex !== -1) {
      return;
    }

    this.userSpaceConversationLabels.push(userSpaceConversationLabel);

  }

  tryUpdateUserSpaceConversationLabel(userSpaceConversationLabel) {

    const userSpaceConversationLabelIndex = findIndexByPropertyValue(this.userSpaceConversationLabels, '_id', userSpaceConversationLabel._id);

    if (userSpaceConversationLabelIndex === -1) {
      return;
    }

    this.userSpaceConversationLabels[userSpaceConversationLabelIndex] = userSpaceConversationLabel;

  }

  tryRemoveUserSpaceConversationLabel(userSpaceConversationLabelId) {

    const userSpaceConversationLabelIndex = findIndexByPropertyValue(this.userSpaceConversationLabels, '_id', userSpaceConversationLabelId);

    if (userSpaceConversationLabelIndex === -1) {
      return;
    }

    this.userSpaceConversationLabels.splice(userSpaceConversationLabelIndex, 1);

  }

  handleUserSpaceConversationLabelCreatedEvent(payload) {

    this.tryAddUserSpaceConversationLabel(payload.conversationLabel);

  }

  handleUserSpaceConversationLabelUpdatedEvent(payload) {

    this.tryUpdateUserSpaceConversationLabel(payload.conversationLabel);

  }

  handleUserSpaceConversationLabelDeletedEvent(payload) {

    this.tryRemoveUserSpaceConversationLabel(payload.conversationLabelId);

  }

  registerEventHandlers() {

    this.application.eventSystem.internal.on(externalEventCodes.USER_SPACE_CONVERSATION_LABEL_CREATED, this.handleUserSpaceConversationLabelCreatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.USER_SPACE_CONVERSATION_LABEL_UPDATED, this.handleUserSpaceConversationLabelUpdatedEvent.bind(this));
    this.application.eventSystem.internal.on(externalEventCodes.USER_SPACE_CONVERSATION_LABEL_DELETED, this.handleUserSpaceConversationLabelDeletedEvent.bind(this));

  }

  getAll() {

    return this.userSpaceConversationLabels;

  }

  async loadAll() {

    this.userSpaceConversationLabels = await serverInterface.startup.users.userSpaceConversationLabels.getUserSpaceConversationLabelsByQueryOptions();

  }

  async create(data) {

    try {

      const userSpaceConversationLabel = await serverInterface.startup.users.userSpaceConversationLabels.createUserSpaceConversationLabel(data);

      this.tryAddUserSpaceConversationLabel(userSpaceConversationLabel);

      return userSpaceConversationLabel;

    } catch (exception) {

      // eslint-disable-next-line no-throw-literal
      throw { message: 'Tag already exists' };

    }

  }
  handleEditLabelException(exception, value) {

    let message = 'Unknown error! Please try again!!';

    if (exception.code === 'USER_SPACE_CONVERSATION_LABEL_ALREADY_EXISTS') {

      message = `Tag: ${value} already exists!`;

    } else if (exception.code === 'ValidationError') {

      const error = exception.metadata[0];

      if (error.keyword === 'minLength') {
        message = 'Please enter valid tag name';
      } else if (error.keyword === 'maxLength') {
        message = 'Tag name cannot exceed 20 characters';
      }

    }

    application.eventSystem.internal.emit(internalEventCodes.DISPLAY_SYSTEM_TOAST_MESSAGE, {
      message,
      seconds: 5,
      type: 'error'
    });

  }

  async update(userSpaceConversationLabelId, data) {

    try {

      const updated = await serverInterface.startup.users.userSpaceConversationLabels.updateUserSpaceConversationLabelById(userSpaceConversationLabelId, data);

      if (updated === true) {
        this.tryUpdateUserSpaceConversationLabel({
          ...data,
          _id: userSpaceConversationLabelId
        });
      }

      return updated;

    } catch (exception) {

      if (exception.code === 'USER_SPACE_CONVERSATION_LABEL_ALREADY_EXISTS') {

        // eslint-disable-next-line no-throw-literal
        throw { alreadyExists: true };

      } else if (exception.code === 'ValidationError') {

        const error = exception.metadata[0];
        let message = null;

        if (error.keyword === 'minLength') {
          message = 'Please enter valid tag name';
        } else if (error.keyword === 'maxLength') {
          message = 'Tag name cannot exceed 20 characters';
        }

        // eslint-disable-next-line no-throw-literal
        throw { message };

      } else {

        // eslint-disable-next-line no-throw-literal
        throw { message: 'Unknown error. Please contact administration!' };

      }

    }

  }

  async delete(userSpaceConversationLabelId) {

    const deleted = await serverInterface.startup.users.userSpaceConversationLabels.deleteUserSpaceConversationLabelById(userSpaceConversationLabelId);

    if (deleted === true) {
      this.tryRemoveUserSpaceConversationLabel(userSpaceConversationLabelId);
    }

    return deleted;
  }

}

export default applyTraits(UserSpaceConversationLabelsManager, [InitializeOnce]);